import { useState, useEffect, useCallback } from "react";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import {
  getDefaultParametersData,
  setDefaultParametersData,
} from "../../../services/user.service";
import { customSort } from "../../../functions/sort.function";
import { useLocation, useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Button from "../../../components/button";
import styles from "./styles.module.css";

registerLocale("es", es);

function EditParameters() {
  const [data, setData] = useState([]);
  const [origdata, setOrigData] = useState([]);
  const [updating, setUpdating] = useState("");

  let { partoedit } = useParams();
  let location = useLocation();

  const refresh = useCallback(() => {
    getDefaultParametersData(partoedit)
      .then((res) => {
        let dbdata = JSON.parse(res.data).params.sort((a, b) =>
          customSort(a.product, b.product)
        );
        setOrigData([...dbdata]);
        setData(dbdata);
      })
      .catch((err) => console.log(err));
  }, [partoedit]);

  useEffect(() => {
    refresh();
  }, [location, partoedit, refresh]);

  const compareArrays = (original, currentData) => {
    const result = [];
    currentData.forEach((row) => {
      let oriRow = original.find((x) => x.product === row.product);
      if (oriRow) {
        if (Object.keys(row).some((rowCol) => row[rowCol] !== oriRow[rowCol])) {
          result.push(row);
        }
      }
    });
    return result;
  };

  const handleClick = () => {
    let valueUpdater = compareArrays(origdata, data);
    if (valueUpdater.length > 0) {
      setUpdating(
        `Actualizando parámetros a las ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })}.`
      );
      setDefaultParametersData(valueUpdater)
        .then((response) => {
          setUpdating(
            `Respuesta recibida a las ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })}:\n${response.data}`
          );
          refresh();
        })
        .catch((error) => {
          console.log(error);
          refresh();
        });
    } else {
      setUpdating("Nada que actualizar");
    }
  };

  const handleProcessRowUpdateError = useCallback((error) => {
    console.log(error.message);
  }, []);

  const mutateRow = useCallback(
    (e) => {
      let nudata = [...data];
      let idx = nudata.findIndex((obj) => obj?.product === e.product);
      nudata[idx] = e;
      setData(nudata);
      return e;
    },
    [data]
  );
  const processRowUpdate = useCallback(
    async (newRow) => {
      // Make the HTTP request to save in the backend
      const response = await mutateRow(newRow);
      return response;
    },
    [mutateRow]
  );

  const parpage2title = { lastprice: "Last Price" };

  const parpage2cols = {
    lastprice: [
      {
        field: "product",
        headerClassName: styles.dataGridHeader,
        align: "center",
        headerAlign: "center",
        headerName: "Producto",
        flex: 1,
        editable: false,
      },
      {
        field: "minsize_q25",
        type: "number",
        headerClassName: styles.dataGridHeader,
        align: "center",
        headerAlign: "center",
        headerName: "Cantidad Q25",
        flex: 1,
        editable: true,
      },
      {
        field: "maxspread_q75",
        type: "number",
        headerClassName: styles.dataGridHeader,
        align: "center",
        headerAlign: "center",
        headerName: "Spread Q75",
        flex: 1,
        editable: true,
      },
    ],
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          Editar parámetros {`${parpage2title[partoedit]}`}
        </h3>
        <Button variant="outline" onClick={() => handleClick()}>
          Actualizar Parámetros
        </Button>
      </div>
      <p
        className={`${styles.statusMessage} ${updating ? styles.statusMessageActive : ""}`}
      >
        {updating}
      </p>
      <div className={styles.tableWrapper}>
        <DataGrid
          getRowId={(row) => `${row.product}_${row.dtime}`}
          processRowUpdate={processRowUpdate}
          onProcessRowUpdateError={handleProcessRowUpdateError}
          getRowClassName={(params) =>
            `${styles.dataGridRow} ${params.indexRelativeToCurrentPage % 2 === 0 ? "" : styles.dataGridRowAlt}`
          }
          rows={data}
          columns={parpage2cols[partoedit]}
          hideFooterPagination
          hideFooterSelectedRowCount
          hideFooter
          sx={{
            border: "none",
            "& .MuiDataGrid-main": {
              border: "none",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 600,
            },
          }}
        />
      </div>
    </div>
  );
}

export default EditParameters;
